import { BaseService } from '../../../../core/services/base.service';
import { Session } from '../../interfaces/package/session.interface';
import { Observable } from 'rxjs';

export abstract class SessionService extends BaseService<Session> {
    abstract override findAll(searchParam: any): Observable<any>;
    abstract override find(id: string): Observable<Session>;
    abstract findByBatchId(batchId: string): Observable<Session[]>;
    abstract findByModuleId(moduleId: string): Observable<Session[]>;
    abstract override create(data: Partial<Session>): Observable<Session>;
    abstract override update(id: string, data: Partial<Session>): Observable<Session>;
    abstract override delete(id: string): Observable<void>;
}
